import Editor from "datatables.net-editor";
const editorFieldsTypeDefault = Editor.models.fieldType;
export { editorFieldsTypeDefault };
